import { useState, useEffect, useRef } from "react";
import Config from "../../Config";


import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";

import InputPagger from "../../helpers/InputPagger";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import Xlsx from "../../exporter/Xlsx";


function Topic(props)
{

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        fraza: '',
        xv_wydawnictwa: '_x_',
        poziom_klasa: '_x_',
        limit: 10,
        page: 1,
        pages: 1,
        show: false
    });
    const [tab, setTab] = useState(null);



    const tabRef = useRef(0); //do druku


    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );

        //filtruj tylko dla comboboxow
        if(filedName == 'xv_wydawnictwa') setTab(null);  
        if(filedName == 'poziom_klasa') setTab(null);  
    }


    const goNextNew = () => {
        console.log("goNext");   
        setTab(null);     
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            fraza: '',
            xv_wydawnictwa: '_x_',
            poziom_klasa: '_x_',
            limit: 10,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {
        setTab(null);
    }

    const getFilter = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1_news,topic_filter', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setFilter(res.result);            
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_news,topic', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(filter == null)
    {
        
        getFilter();
        return <div>
            ...
        </div>
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }

 
 
 


    return (
        <div className="view_content">
      

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                }  

                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                            <div className="filter_controll">   
                                <label>Wydawnictwo: </label>                             
                                <InputCombo   userData={props.userData} value={filterParam.xv_wydawnictwa}  items={filter.xv_wydawnictwa}  valChange={valChangeListener} goNext={goNextNew} name="xv_wydawnictwa" placeholder={"Wydawnictwo: "}   />
                            </div>    

                            <div className="filter_controll">   
                                <label>Poziom / Klasa: </label>                             
                                <InputCombo   userData={props.userData} value={filterParam.poziom_klasa}  items={filter.poziom_klasa}  valChange={valChangeListener} goNext={goNextNew} name="poziom_klasa" placeholder={"Poziom: "}   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Fraza: </label>                             
                                <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                            </div>  

                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                  </div>
                }             

              


               <div className="bg_center">

   
                    <div className="table_widget">

                          <Csv tabRef={tabRef} title="Tematy zajęć.csv" />
                          <Xlsx tabRef={tabRef} title="Tematy zajęć.xlsx" />
                  
                          <Print tabRef={tabRef} />

                          <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                    </div>

                  <div className="scorll_x">
                    <table className="table" ref={tabRef}>
                                <thead>
                                    <tr className="header">
                                        <td className="td_left">LP</td>
                                        <td>Wydawnictwo</td>
                                        <td>Temat dnia</td>
                                        <td>Poziom / Klasa</td>
                                        <td className="td_right">Treść</td>                               
                                    </tr>
                                </thead>
                                <tbody>

                                    { 
                                            tab.map( (row,ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return <tr className={rowStyle}>
                                                            <td className="gocenter">{ ix+1 }</td>
                                                            <td>{row.nazwa_wydawnictwa}</td>
                                                            <td>{row.temat_dnia}</td>
                                                            <td>{row.poziom_klasa}</td>
                                                            <td>{row.tresc_zajec}</td>  
                                                    </tr>

                                            } )                                
                                    }

                                </tbody>
                    </table>
                </div>
               </div>

         


        </div>
    )
}


export default Topic;
